export default {
  saturationCurves: 'Curvas de Saturación',
  generalView: 'Vista General',
  optimalZones: 'Zonas Óptimas',
  noOptimalZonesData: '{name} no incluye datos de Zonas Óptimas.',
  marginalRoas: 'Marginal ROAS',
  showHistoricalSpend: 'Puntos de gasto histórico',
  showSpend: 'Puntos de gasto',
  exportCurves: 'Exportar curvas',
  spendUnit: 'Unidad de Gasto',
  spend: 'Gasto',
  monthly: 'Mensual',
  weekly: 'Semanal',
  quarterly: 'Trimestral',
  yearly: 'Anual',
  monthlyAvg: 'Promedio Mensual',
  quarterlyAvg: 'Promedio Trimestral',
  yearlyAvg: 'Promedio Anual',
  none: 'Ninguno',
  ok: 'Ok',
  cancel: 'Cancelar',
  save: 'Guardar',
  aboutOptimalZones: 'Acerca de las Zonas Óptimas',
  zone1: 'Zona 1',
  zone1Desc: 'Este rango generalmente debe evitarse, ya que está por debajo del Umbral Mínimo de Gasto, resultando en contribuciones insignificantes. Cualquier dólar gastado en esta zona es esencialmente desperdiciado.',
  zone2: 'Zona 2',
  zone2Desc: 'En este rango, los dólares gastados comienzan a mostrar una contribución marginal pequeña pero de rápido crecimiento. Típicamente, pequeños incrementos en el gasto generan altas ganancias en contribución marginal, hasta el punto donde se alcanza la Contribución Marginal Máxima.',
  zone3: 'Zona 3',
  zone3Desc: 'Este rango, junto con el siguiente, generalmente se considera "óptimo". A medida que el gasto aumenta en este rango, la contribución marginal de cada dólar adicional gastado disminuye gradualmente, aunque el Retorno sobre la Inversión Publicitaria (ROAS) de cada dólar continúa creciendo.',
  zone4: 'Zona 4',
  zone4Desc: 'Este rango, junto con el anterior, generalmente se considera "óptimo". Sin embargo, a diferencia de la Zona 3, a medida que el gasto aumenta en este rango, el ROAS disminuye gradualmente, haciendo que el gasto adicional sea cada vez menos eficiente.',
  zone5: 'Zona 5',
  zone5Desc: 'Similar a la Zona 1, este rango generalmente debe evitarse, ya que representa gasto más allá de lo eficiente. En esta zona, la contribución de cada dólar adicional es tan pequeña que es esencialmente un desperdicio de recursos.',
  aboutMarginalRoas: 'Acerca del Marginal ROAS',
  marginalRoasDesc: 'El Marginal ROAS (mROAS) es el retorno incremental que genera cada unidad adicional de inversión, es decir, la pendiente (derivada) de la curva de saturación. Cada gráfico superpone la curva de saturación (eje izquierdo) con su curva marginal (eje derecho): el valor marginal en un nivel de inversión dado es la diferencia de contribución incremental dividida por la diferencia de inversión entre ese nivel y el anterior.',
  averageCpi: 'CPI Promedio',
  enterCpiInstructions: 'Ingrese el Costo Por Impresión promedio (MXN) para cada canal de medios:',
  editAverageCpi: 'Editar Costo Por Impresión Promedio'
}
